import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Column } from 'react-table'
import Table from '../../../../../../global/components/table/Table'
import TableTopper from '../../../../../../global/components/table/helpers/table-topper/TableTopper'
import TableTitle from '../../../../../../global/components/table/helpers/table-title/TableTitle'
import WODetailsSubModal from '../../sub-modals/WODetailsSubModal'
import { fetchData } from '../../../../../../global/utils/fetch'
import { getOrderVehiclesById } from '../../../../api'
import { IOrderVehicle } from '../../../../../../../../app/entities/OrderVehicle'
import { SUB_MODAL_NAMES } from '../../sub-modals/constants'

export default function WorkOrderVehiclesTable({
  isReadOnly = false,
}: {
  isReadOnly?: boolean
}) {
  const { id } = useParams()
  const [tableState, setTableState] = useState({
    data: [],
    isLoading: false,
  })
  const [isOpen, setIsOpen] = useState(true)
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [modalName, setModalName] = useState<string>('')
  const [orderVehicleObjId, setOrderVehicleObjId] = useState(undefined)
  const [refreshIndex, setRefreshIndex] = useState(0)

  const handleClosed = () => {
    setEditModalOpen(false)
    setModalName('')
  }
  const onRecordClickHandler = (row: any) => {
    if (isReadOnly) return
    const { original } = row
    setModalName(SUB_MODAL_NAMES.DELETE_VEHICLE)
    setOrderVehicleObjId(original.objectId)
    setEditModalOpen(true)
  }

  useEffect(() => {
    const fetchTableData = async () => {
      setTableState((prevState) => ({
        ...prevState,
        isLoading: true,
      }))
      const data = await fetchData<IOrderVehicle[]>(getOrderVehiclesById(id))

      setTableState((prevState: any) => ({
        ...prevState,
        data: data,
        isLoading: false,
      }))
    }
    fetchTableData()
  }, [refreshIndex, id])

  const columns: Column<any>[] = [
    {
      Header: 'Vehicle ID',
      accessor: 'orderVehicleId',
    },
    {
      Header: 'Make & Model',
      Cell: ({ row: { original } }) => {
        const { customerVehicle } = original as IOrderVehicle

        return (
          <div>
            <div>{customerVehicle?.brand?.name}</div>
            <div>{customerVehicle?.model}</div>
            {customerVehicle?.variant}
            <div>{customerVehicle?.year}</div>
          </div>
        )
      },
    },
    {
      Header: 'Tire Count',
      Cell: ({ row: { original } }) => {
        const { tiresCombination } = original as IOrderVehicle

        return (
          <div>
            <div>Front: {tiresCombination?.frontCount}</div>
            <div>Rear: {tiresCombination?.rearCount}</div>
          </div>
        )
      },
    },
    {
      Header: 'Front Specs',
      Cell: ({ row: { original } }) => {
        const { tiresCombination } = original as IOrderVehicle
        const frontTire = tiresCombination ? tiresCombination.frontTire : null

        return (
          <div>
            <div>Width: {frontTire?.width}</div>
            <div>Aspect Ratio: {frontTire?.aspectRatio}</div>
            <div>Diameter: {frontTire?.diameter}</div>
            <div>PSI: {frontTire?.psi}</div>
          </div>
        )
      },
    },
    {
      Header: 'Rear Specs',
      Cell: ({ row: { original } }) => {
        const { tiresCombination } = original as IOrderVehicle
        const rearTire = tiresCombination ? tiresCombination.rearTire : null

        return (
          <div>
            <div>Width: {rearTire?.width}</div>
            <div>Aspect Ratio: {rearTire?.aspectRatio}</div>
            <div>Diameter: {rearTire?.diameter}</div>
            <div>PSI: {rearTire?.psi}</div>
          </div>
        )
      },
    },
    {
      Header: 'Torque',
      Cell: ({ row: { original } }) => {
        const { tiresCombination } = original as IOrderVehicle as any

        return (
          tiresCombination?.rearTire?.torque ||
          tiresCombination?.frontTire?.torque ||
          'N/A'
        )
      },
    },
    {
      Header: 'Tire Make & Model',
      Cell: ({ row: { original } }) => {
        const { tiresCombination } = original as IOrderVehicle

        const { rearTire, frontTire } = tiresCombination || {}
        const tire = rearTire || frontTire

        return (
          <div>
            <div>{tire?.manufacturer || 'N/A'}</div>
            <div>{tire?.model || 'N/A'}</div>
          </div>
        )
      },
    },
    {
      Header: 'Mileage',
      accessor: 'mileage',
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      <TableTopper
        isOpen={isOpen}
        onToggleClick={() => setIsOpen(!isOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <TableTitle>Work Order Vehicles Information</TableTitle>
        </div>
        <WODetailsSubModal
          isOpen={editModalOpen}
          handleClosed={handleClosed}
          actionName={modalName}
          triggerRerender={() => setRefreshIndex(refreshIndex + 1)}
          isDeleteOrderVehicleButtonVisible={tableState.data.length >= 2}
          orderVehicleObjId={orderVehicleObjId}
        />
      </TableTopper>
      <Table
        columns={columns}
        data={tableState.data}
        isLoading={tableState.isLoading}
        onRowClick={onRecordClickHandler}
        isOpen={isOpen}
        isDisplayMode={true}
      />
    </div>
  )
}
